interface IPaths {
	BASE_URL: string;
	LOGIN_PATH: string;
	BASE_APP_URL: string;
	REGISTRATION_PATH: string;
	PASSWORD_RESET_PATH: string;
	ACCOUNT_PAGE_PATH: string;
	DISSERTATION_SUBMISSIONS_PATH: string;
	DISSERTATION_DETAILS_PATH: string;
	EXAMINER_SCORESHEET_PATH: string;
	EXAMINER_FEEDBACK_PATH: string;
	EVENT_REGISTRATION_PATH: string;
	EVENT_PAYMENT_CALLBACK_PATH: string;
	[x: string]: string;
}

const paths = {} as IPaths;

paths.BASE_URL = "/";
paths.LOGIN_PATH = paths.BASE_URL + "login";
paths.PASSWORD_RESET_PATH = paths.BASE_URL + "password-reset";

paths.BASE_APP_URL = paths.BASE_URL + "app/";
paths.REGISTRATION_PATH = paths.BASE_APP_URL + "registration";
paths.ACCOUNT_PAGE_PATH = paths.BASE_APP_URL + "accounts/manage";
paths.DISSERTATION_SUBMISSIONS_PATH = paths.BASE_APP_URL + "dissertation/new";
paths.DISSERTATION_DETAILS_PATH = paths.BASE_APP_URL + "dissertation/view";
paths.EXAMINER_SCORESHEET_PATH = paths.BASE_URL + "/examiner-view/dissertation/:dissertationId/:examinerId/scoresheet";
paths.EXAMINER_FEEDBACK_PATH = paths.BASE_URL + "/examiner-view/dissertation/:dissertationId/:examinerId/feedback";
paths.EVENT_REGISTRATION_PATH = paths.BASE_URL + "events/register";
paths.EVENT_PAYMENT_CALLBACK_PATH = paths.BASE_URL + "events/payment/callback";

export const routes = paths;